export default async function UpdateProjectPlotSpecification(sendForm) {
    let url = window.RealestateService+  `/api/ProjectPlotDetails/UpdateProjectPlotSpecification`
    let head = {
        "content-type":"application/json",
        "accept":"*/*"
    }
    let data ={}
    let response  = await fetch(url, {
        method:"PUT",
        headers:head,
        body:JSON.stringify(sendForm)
    }).then(res=>res.json()).then(data)

    return response
}